import { ApolloClient, InMemoryCache, gql } from "@apollo/client";

// RAG GraphQL endpoint - UPDATE THIS WITH YOUR ACTUAL ENDPOINT
const RAG_GRAPHQL_ENDPOINT =
  "https://w36vpphy6vbkpmv3d4rgkxvnnq.appsync-api.us-east-1.amazonaws.com/graphql";

// Initialize Apollo Client for RAG services
const ragClient = new ApolloClient({
  uri: RAG_GRAPHQL_ENDPOINT,
  cache: new InMemoryCache(),
  headers: {
    "x-api-key": "da2-ver43gz5yjepbhgbdgtjohdrzm", // RAG API Key
  },
});

// RAG API methods
export const processDocument = async (input) => {
  const mutation = gql`
    mutation ProcessDocument($input: ProcessDocumentInput!) {
      processDocument(input: $input) {
        success
        documentId
        executionId
        error
      }
    }
  `;

  try {
    const response = await ragClient.mutate({
      mutation,
      variables: { input },
    });
    return response.data.processDocument;
  } catch (error) {
    console.error("Error processing document:", error);
    throw error;
  }
};

export const queryRAG = async (input) => {
  const query = gql`
    query QueryRAG($input: RAGQueryInput!) {
      queryRAG(input: $input) {
        success
        result {
          query
          response
          context {
            chunkId
            text
            score
            metadata
          }
          executionId
          modelId
          timestamp
          tenantId
        }
        error
      }
    }
  `;

  try {
    const response = await ragClient.query({
      query,
      variables: { input },
    });
    return response.data.queryRAG;
  } catch (error) {
    console.error("Error querying RAG:", error);
    throw error;
  }
};

export const getDocument = async (documentId, tenantId) => {
  const query = gql`
    query GetDocument($documentId: String!, $tenantId: String!) {
      getDocument(documentId: $documentId, tenantId: $tenantId) {
        documentId
        filename
        contentType
        size
        chunkCount
        status
        tenantId
        createdAt
        updatedAt
        metadata
      }
    }
  `;

  try {
    const response = await ragClient.query({
      query,
      variables: { documentId, tenantId },
    });
    return response.data.getDocument;
  } catch (error) {
    console.error("Error getting document:", error);
    throw error;
  }
};

export const listDocuments = async (tenantId, status, limit) => {
  const query = gql`
    query ListDocuments($tenantId: String!, $status: String, $limit: Int) {
      listDocuments(tenantId: $tenantId, status: $status, limit: $limit) {
        documentId
        filename
        contentType
        size
        chunkCount
        status
        tenantId
        createdAt
        updatedAt
        metadata
      }
    }
  `;

  try {
    const variables = { tenantId };
    if (status !== null && status !== undefined) variables.status = status;
    if (limit !== null && limit !== undefined) variables.limit = limit;

    const response = await ragClient.query({
      query,
      variables,
    });
    return response.data.listDocuments;
  } catch (error) {
    console.error("Error listing documents:", error);
    throw error;
  }
};

export const getDocumentChunks = async (documentId, tenantId) => {
  const query = gql`
    query GetDocumentChunks($documentId: String!, $tenantId: String!) {
      getDocumentChunks(documentId: $documentId, tenantId: $tenantId) {
        chunkId
        documentId
        text
        length
        chunkIndex
        hasOverlap
        overlapSize
        metadata
      }
    }
  `;

  try {
    const response = await ragClient.query({
      query,
      variables: { documentId, tenantId },
    });
    return response.data.getDocumentChunks;
  } catch (error) {
    console.error("Error getting document chunks:", error);
    throw error;
  }
};

export const getRAGStats = async (tenantId) => {
  const query = gql`
    query GetRAGStats($tenantId: String!) {
      getRAGStats(tenantId: $tenantId) {
        totalDocuments
        totalChunks
        totalQueries
        averageChunksPerDocument
        documentsByStatus {
          status
          count
        }
        recentQueries {
          query
          response
          executionId
          modelId
          timestamp
          tenantId
        }
      }
    }
  `;

  try {
    const response = await ragClient.query({
      query,
      variables: { tenantId },
    });
    return response.data.getRAGStats;
  } catch (error) {
    console.error("Error getting RAG stats:", error);
    throw error;
  }
};

export const updateDocument = async (input) => {
  const mutation = gql`
    mutation UpdateDocument($input: UpdateDocumentInput!) {
      updateDocument(input: $input) {
        success
        document {
          documentId
          filename
          contentType
          size
          chunkCount
          status
          tenantId
          createdAt
          updatedAt
          metadata
        }
        error
      }
    }
  `;

  try {
    const response = await ragClient.mutate({
      mutation,
      variables: { input },
    });
    return response.data.updateDocument;
  } catch (error) {
    console.error("Error updating document:", error);
    throw error;
  }
};

export const deleteDocument = async (documentId, tenantId) => {
  const mutation = gql`
    mutation DeleteDocument($documentId: String!, $tenantId: String!) {
      deleteDocument(documentId: $documentId, tenantId: $tenantId) {
        success
        error
      }
    }
  `;

  try {
    const response = await ragClient.mutate({
      mutation,
      variables: { documentId, tenantId },
    });
    return response.data.deleteDocument;
  } catch (error) {
    console.error("Error deleting document:", error);
    throw error;
  }
};
